<!-- Checkbox tick box visual with checked, readonly, and error states. -->

<script lang="ts" setup>
import Tick from '../Tick.vue';

defineProps({
  checked: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  hasError: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
</script>

<template>
  <div
    :class="[
      css.tick,
      checked && css.checked,
      readonly && css.readonly,
      hasError && !disabled && !readonly && css.error,
    ]"
  >
    <Tick :show="checked" />
  </div>
</template>

<style lang="scss" module="css">
$checkbox-size: 20px;

.tick {
  transform: translate3d(0, 0, 0);
  position: relative;
  flex: 0 0 $checkbox-size;
  font-size: $font-size-12;
  width: $checkbox-size;
  height: $checkbox-size;
  border-radius: $border-radius-04;
  border: 1px solid $color-gray-600;
  background: $color-white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color ease-out 0.2s,
    border-color ease-out 0.2s;
  margin-right: $spacing-08;
  color: $color-white;

  &.checked {
    animation: wave 0.25s ease;
    background-color: $color-text !important;
    border-color: $color-text !important;
    color: $color-white !important;

    &.readonly {
      background-color: $color-gray-400 !important;
      border-color: $color-gray-400 !important;
    }
  }

  &.error {
    border-color: $color-patient-600;

    &.checked {
      background-color: $color-patient-500 !important;
      border-color: $color-patient-500 !important;
    }
  }
}

@keyframes wave {
  50% {
    transform: scale(0.85);
  }
}
</style>
